// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

::ng-deep .classification 
.mat-paginator-outer-container 
.mat-paginator-container 
.mat-paginator-range-actions 
.mat-icon-button {    padding: 0;
  min-width: 0;
  width: 22px;
  height: 40px;
  flex-shrink: 0;
  line-height: 40px;
  border-radius: 50%;} 
::ng-deep .specification 
.mat-paginator-outer-container 
.mat-paginator-container 
.mat-paginator-range-actions 
.mat-icon-button {    padding: 0;
  min-width: 0;
  width: 22px;
  height: 40px;
  flex-shrink: 0;
  line-height: 40px;
  border-radius: 50%;}


 ::ng-deep .popover{width: 200px !important;}
::ng-deep .popover .popover-body .mat-table__wrapper{width: 100% !important; overflow: hidden !important;}

::ng-deep .popover .popover-body{width: 200px !important;}
::ng-deep .popover {
  height: 150px;
  max-width: unset;
  min-width: 200px !important;
  overflow-y: scroll;
  overflow-x: hidden;
}
.mat-table__wrapper {
  overflow: hidden;
}

.mt-60 {
    margin-top: 60px;
  }
  
  .break-title {
    word-wrap: break-word !important;
    font-size: 13px !important;
  }
  .footer-modal {
    flex: 0 0 auto;
  }
  ::ng-deep mat-dialog-container {
    /* overflow-y: hidden !important */
    
  }
  ::ng-deep .modal-media {
    position: relative !important;
    /* overflow-y: auto !important */
    ;
  }
  
  .modal-media {
    position: relative !important;
    overflow-y: auto !important
    ;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/folders/add-edit-folder/add-edit-folder.component.css"],"names":[],"mappings":";;AAEA;;;;sBAIsB,UAAU;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB,CAAC;AACrB;;;;sBAIsB,UAAU;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB,CAAC;;;CAGpB,mBAAmB,uBAAuB,CAAC;AAC5C,qDAAqD,sBAAsB,EAAE,2BAA2B,CAAC;;AAEzG,iCAAiC,uBAAuB,CAAC;AACzD;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,kCAAkC;;EAEpC;EACA;IACE,6BAA6B;IAC7B,gCAAgC;;EAElC;;EAEA;IACE,6BAA6B;IAC7B;IACA;EACF","sourcesContent":["\r\n\r\n::ng-deep .classification \r\n.mat-paginator-outer-container \r\n.mat-paginator-container \r\n.mat-paginator-range-actions \r\n.mat-icon-button {    padding: 0;\r\n  min-width: 0;\r\n  width: 22px;\r\n  height: 40px;\r\n  flex-shrink: 0;\r\n  line-height: 40px;\r\n  border-radius: 50%;} \r\n::ng-deep .specification \r\n.mat-paginator-outer-container \r\n.mat-paginator-container \r\n.mat-paginator-range-actions \r\n.mat-icon-button {    padding: 0;\r\n  min-width: 0;\r\n  width: 22px;\r\n  height: 40px;\r\n  flex-shrink: 0;\r\n  line-height: 40px;\r\n  border-radius: 50%;}\r\n\r\n\r\n ::ng-deep .popover{width: 200px !important;}\r\n::ng-deep .popover .popover-body .mat-table__wrapper{width: 100% !important; overflow: hidden !important;}\r\n\r\n::ng-deep .popover .popover-body{width: 200px !important;}\r\n::ng-deep .popover {\r\n  height: 150px;\r\n  max-width: unset;\r\n  min-width: 200px !important;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n.mat-table__wrapper {\r\n  overflow: hidden;\r\n}\r\n\r\n.mt-60 {\r\n    margin-top: 60px;\r\n  }\r\n  \r\n  .break-title {\r\n    word-wrap: break-word !important;\r\n    font-size: 13px !important;\r\n  }\r\n  .footer-modal {\r\n    flex: 0 0 auto;\r\n  }\r\n  ::ng-deep mat-dialog-container {\r\n    /* overflow-y: hidden !important */\r\n    \r\n  }\r\n  ::ng-deep .modal-media {\r\n    position: relative !important;\r\n    /* overflow-y: auto !important */\r\n    ;\r\n  }\r\n  \r\n  .modal-media {\r\n    position: relative !important;\r\n    overflow-y: auto !important\r\n    ;\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
